import { type InputTypeProps } from "@common/declarations";
import * as React from "react";

export type RangeProps = InputTypeProps<number> & {
  name?: string;
  min: number;
  max: number;
  step: number;

  isDisabled?: boolean;

  onBlur?: () => void;
};

const Range = (props: RangeProps) => {
  const onChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      props.onChange(+e.target.value);
    },
    [props.onChange]
  );

  return (
    <input
      onMouseMoveCapture={(e) => e.stopPropagation()}
      className="range_input"
      disabled={props.isDisabled}
      name={props.name}
      type="range"
      min={props.min}
      max={props.max}
      step={props.step}
      value={props.value}
      onMouseUp={props.onBlur}
      onInput={onChange}
      data-name={props.qa || props.name}
    />
  );
};

export default Range;
